var map = {
	"./brands.json": [
		656,
		749
	],
	"./custom-icons.json": [
		657,
		750
	],
	"./full-color.json": [
		658,
		751
	],
	"./light.json": [
		659,
		752
	],
	"./solid.json": [
		660,
		753
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 645;
module.exports = webpackAsyncContext;